import { useEffect } from "react";
import { config } from "../environment";
import { useToast } from "./Toast";

const MAINTENANCE_END_AT = Date.parse("2026-09-06T15:00:00-04:00");
const MAINTENANCE_STATUS_URL = "https://status.tines.com/incidents/eq4SQ0";
const LAST_SHOWN_KEY = "3b-september-2026-maintenance-shown-at";
const REAPPEAR_AFTER_MS = 24 * 60 * 60 * 1000;

// Remember when we last showed it so it reappears at most once a day rather than
// on every page load; storage-blocked browsers throw, so fall back to showing.
function shownRecently(): boolean {
  try {
    const shownAt = Number(localStorage.getItem(LAST_SHOWN_KEY));
    return shownAt > 0 && Date.now() - shownAt < REAPPEAR_AFTER_MS;
  } catch {
    return false;
  }
}

function markShown(): void {
  try {
    localStorage.setItem(LAST_SHOWN_KEY, String(Date.now()));
  } catch {}
}

export function MaintenanceToast() {
  const { showToast } = useToast();

  useEffect(() => {
    if (config.selfHostedSingleTenant || Date.now() >= MAINTENANCE_END_AT)
      return;
    if (shownRecently()) return;

    markShown();
    showToast({
      key: "september-2026-maintenance",
      icon: "traffic-cone",
      message: "Upcoming maintenance Sep 6, 12–3 PM ET",
      buttonLabel: "Details",
      buttonTo: MAINTENANCE_STATUS_URL,
      buttonTarget: "_blank",
      persist: true,
      dismissible: true,
    });
  }, [showToast]);

  return null;
}
